import React, { useEffect, useMemo, useState } from 'react'
import {
  GoToShardAction,
  AnyActionType,
  IShard,
  IActionComponentProps,
} from '~core/forge.type'
import useDispatch from '~editor/hooks/useDispatch'
import { Select } from '~editor/components/Select'
import { client } from '~editor/utils/gg_client'
import { SetRequired } from 'type-fest'
import { Box } from '@chakra-ui/react'

interface IProps extends IActionComponentProps {
  action: GoToShardAction
}

interface IOption {
  label: string
  value: string
}

export const GoToShardActionComponent = ({
  action,
  actions,
  activeActionGesture,
  isDisabled,
}: IProps) => {
  const dispatch = useDispatch()
  const [options, setOptions] = useState<IOption[]>([])
  const selectedOption: IOption | undefined = useMemo(() => {
    return options.find((option) => parseInt(option.value) === action.shardId)
  }, [options, action?.shardId])

  useEffect(() => {
    client
      .get('/users/@me/shards?limit=1000')
      .then((res) => {
        const shards = (
          res.data.results as SetRequired<IShard, 'id' | 'name'>[]
        ).sort((a, b) => {
          const aUpdatedAt = new Date(a.updated_at!)
          const bUpdatedAt = new Date(b.updated_at!)

          if (aUpdatedAt > bUpdatedAt) return -1
          if (aUpdatedAt < bUpdatedAt) return 1

          return 0
        })

        setOptions(
          shards.map((shard) => {
            return {
              label: shard.name,
              value: `${shard.id}`,
            }
          }),
        )
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])

  return (
    <Box width="100%">
      <Select
        width="100%"
        height="32px"
        value={selectedOption}
        options={options}
        placeholder="Select option"
        isDisabled={isDisabled}
        onChange={(option) => {
          if (option) {
            const shardId = parseInt((option as any)?.value)
            if (isNaN(shardId)) return

            dispatch.nodes.updateActions({
              actionGestureType: activeActionGesture,
              actions: actions.map((_a: AnyActionType) => {
                const _action = { ..._a } as GoToShardAction

                if (action.id === _action.id) {
                  _action.shardId = shardId
                }

                return _action
              }),
            })
          }
        }}
      />
    </Box>
  )
}

export default GoToShardActionComponent
